enum TitleTag {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  DIV = 'div',
}

export default TitleTag;
